import * as Yup from "yup";

import { validationObject as citizenshipPepObject } from "Components/Form/CommonFormElements/CitizenshipPepFormElement/validation";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { PregnantAndNewbornIntroFormValues } from "./pregnantAndNewbornProductIntroInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<PregnantAndNewbornIntroFormValues> => {
    const { getText } = TextManager;
    return Yup.object({
      parentGuardian: Yup.mixed<BooleanFormType>()
        .oneOf([BooleanFormType.TRUE], "")
        .required(getText("pregnantandnewbornform.validation.parentguardian")),
      ...citizenshipPepObject(),
    }).defined();
  };
